import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { getblog } from "../../redux/BlogDetail";
import { useDispatch, useSelector } from "react-redux";
import MetaComponent from '../../components/MetaComponent';
import Skeleton from '@material-ui/lab/Skeleton';
import AOS from 'aos';

function BlogDetailComponent() {
  const dispatch = useDispatch();
   const { blogdata, isBlogLoading } = useSelector((state) => state.blogdata);
   const params = useParams()

  const [finalDate,setfinalDate] = useState("");
  function getDate(blogdata){
    console.log(blogdata.data);
    if(blogdata === undefined|| blogdata.data===undefined){
    } else{
      const currentDate = blogdata.data[0].date_gmt;
      const finalYear = currentDate.slice(0, 4);
      const getMonth = currentDate.slice(5, 7);
      const getDate = currentDate.slice(8, 10);
      const finalMonth = getMonth;
      const finalDate = getDate + "-" + "" + finalMonth + "" + "-" + finalYear;
      setfinalDate(finalDate);
    }
  }

  useEffect(() => {
    dispatch(getblog({ slug: params.id }));
    AOS.init();
    // AOS TRIGGER FIX
    var init = [];
    var x = setInterval(function () {
      init.push(AOS.init());
      if (init.length >= 2) {
        clearInterval(x);
      }
    }, 1000)

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [dispatch]);

  // console.log(blogdata.data[0]);
  useEffect(() => {
    getDate(blogdata);
  }, [blogdata]);
  return (
    <div>
      <></>
        {blogdata?.data === undefined || blogdata === null || isBlogLoading === true ? (
            <div className="container" style={{minHeight:`500px`}}>
            </div>
          ) : (
          <>
          {console.log(blogdata.data[0].date_gmt)}
          {blogdata.data[0] ? "" : <Redirect to="/blogs" />}
          <MetaComponent title={blogdata.data[0] ? blogdata.data[0].yoast_head_json.og_title : null} description={blogdata.data[0] ? blogdata.data[0].yoast_head_json.og_description : null}/>
          {blogdata.data[0]?.yoast_head_json.og_image && blogdata.data[0]?.yoast_head_json.og_image.length !==0 ?
          <div className="ImageHeader" style={{background:`url(${blogdata.data[0] ? blogdata.data[0].yoast_head_json.og_image[0].url : null})`,backgroundRepeat:`no-repeat`,backgroundSize:`cover`,height:`400px`,backgroundPosition:`left center`}}>
          {/* <img data-aos="fade-up" className="w-100" data-aos-duration="700" src={blogdata.data[0].yoast_head_json.og_image[0].url}></img> */}
          </div>
          : null}
          <div className={blogdata.data[0]?.yoast_head_json.og_image ? "container" : "mt-4 pt-4 mt-md-5 pt-md-5 container"}>
            <div className="postHeader postHeaderMargin">
              <div className="row justify-content-start align-items-center">
                <div className="col-xl-9">
                    {/* <div data-aos="fade-up" data-aos-duration="700" className="postDate mb-5 textModule1 d-flex">
                      <span className="mt-0"></span>
                      <span className="mt-0">By </span>
                      <span className="mt-0 ms-2">Adeeb</span>
                    </div> */}
                    <h1 data-aos="fade-up" data-aos-duration="700" className="postContentTitle">{blogdata.data[0] ? blogdata.data[0].title.rendered : null}</h1>
                    <div data-aos="fade-up" data-aos-duration="700" className="postDateInner">
                      <span>Published on {finalDate}</span>
                    </div>
                </div>
                {/* <div className="col-xl-3">
                  <img data-aos="fade-up" className="w-100" data-aos-duration="700" src={blogdata.data[0].yoast_head_json.og_image[0].url}></img>
                </div> */}
              </div>
              <hr class="mb-5 mt-4 customHR"></hr>
              <div className="row mt-4">
                <div className="col-xl-12 postBox">
                  <div data-aos="fade-up" data-aos-duration="700" dangerouslySetInnerHTML={{__html: blogdata.data[0] ? blogdata.data[0].content.rendered : null}} className="postContent"></div>
                </div>
              </div>
            </div>
            <h2 className="text-center relatedBlogHeading"></h2>
            {/* <RelatedPosts/> */}
          </div>
          </>
      )} 
    </div>
  );
}

export default BlogDetailComponent;
